import Vue from 'vue';

Vue.component('vuetable-daily-sales', () =>
    import(/* webpackChunkName: 'daily-sales-index' */ './vuetable-daily-sales.vue'),
);

Vue.component('vuetable-till-closure', () =>
    import(/* webpackChunkName: 'card-sales-show' */ './vuetable-till-closure.vue'),
);

Vue.component('show-daily-sales', () =>
    import(/* webpackChunkName: 'daily-sales-show' */ './show-daily-sales.vue'),
);

Vue.component('show-daily-sales-vertical', () =>
    import(/* webpackChunkName: 'daily-sales-show' */ './show-daily-sales-vertical.vue'),
);

Vue.component('show-daily-sales-v3', () =>
    import(/* webpackChunkName: 'daily-sales-show' */ './show-daily-sales-v3.vue'),
);

Vue.component('show-card-sales', () =>
    import(/* webpackChunkName: 'card-sales-show' */ './show-card-sales.vue'),
);

Vue.component('show-card-sales-old', () =>
    import(/* webpackChunkName: 'card-sales-show' */ './show-card-sales-old.vue'),
);

Vue.component('show-card-edc-sales', () =>
    import(/* webpackChunkName: 'card-edc-sales-show' */ './show-card-edc-sales.vue'),
);

Vue.component('till-summary-report', () =>
    import(/* webpackChunkName: 'till-summary-report' */ './till-summary-report.vue'),
);

Vue.component('collected-report', () =>
    import(/* webpackChunkName: 'collected-report' */ './show-collected-report.vue'),
);

Vue.component('till-closure-list', () =>
    import(/* webpackChunkName: 'till-closure-list' */ './till-closure-list.vue'),
);

Vue.component('vuetable-till-list', () =>
    import(/* webpackChunkName: 'card-sales-show' */ './vuetable-till-list.vue'),
);

Vue.component('show-till-card-sales', () =>
    import(/* webpackChunkName: 'card-till-sales-show' */ './show-till-card-sales.vue'),
);

Vue.component('show-till-card-sales-old', () =>
    import(/* webpackChunkName: 'card-till-sales-show' */ './show-till-card-sales-old.vue'),
);

Vue.component('show-till-card-edc-sales', () =>
    import(/* webpackChunkName: 'card-till-edc-sales-show' */ './show-till-card-edc-sales.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/daily-sales/index.js